// extracted by mini-css-extract-plugin
export const root = "HomeHero-module--root--3vNm0";
export const logo = "HomeHero-module--logo--3JvOw";
export const tagline = "HomeHero-module--tagline--2N6eQ";
export const footer = "HomeHero-module--footer--1ct03";